export const COLORS = {
  LIGHT_GREY: '#f5f5f5',
  DARK_GREY: '#a9a9a9',
  MAROON: '#800000',
  OLIVE: '#808000',
  TEAL: '469990',
  NAVY: '#000075',
  RED: "#b80000",
  ORANGE: "#db3e00",
  YELLOW: "#fccb00",
  GREEN: "#008b02",
  LIME: '#bfef45',
  CYAN: "#42d4f4",
  BLUE: "#1273de",
  DARK_BLUE: "#004dcf",
  PURPLE: "#911eb4",
  MAGENTA: '#f032e6',
  PINK: '#fabed4',
  APRICOT: '#ffd8b1',
  MINT: '#aaffc3',
  LAVENDAR: 'dcbeff',
  LIGHT_RED: "#eb9694",
  LIGHT_ORANGE: "#faD0c3",
  LIGHT_YELLOW: "#fef3bd",
  LIGHT_GREEN: "#c1e1c5",
  LIGHT_CYAN: "#bedadc",
  LIGHT_BLUE: "#c4def6",
  LIGHT_DARK_BLUE: "#bed3f3",
  LIGHT_PURPLE: "#d4c4fb",
  WHITE: '#fffFFF',
  PRIMARY_PURPLE: '#756dff',
  CANCEL_BUTTON: '#c70000',
  SUCCESS_BUTTON: '#42ba96',
  BLACK: '#000000',
  TRANSPARENT: '#00000000',
  TRANSLUCENT: "rgba(255, 255, 255, 0.5)", 
}

export const colorPickerArray = [
  COLORS.MAROON,
  COLORS.RED,
  COLORS.ORANGE,
  COLORS.YELLOW,
  COLORS.APRICOT,
  COLORS.LIME,
  COLORS.MINT,
  COLORS.GREEN,
  COLORS.NAVY,
  COLORS.CYAN,
  COLORS.BLUE,
  COLORS.DARK_BLUE,
  COLORS.PURPLE,
  COLORS.MAGENTA,
  COLORS.PINK,
  COLORS.OLIVE,
]
